module.exports = __webpack_public_path__ + "static/media/buildingConstruction7.d98ca1f9.jpg";